import axios from "axios";
import { IP } from "./config";
// 查询分类
export async function selectCategory() {
  var resp = await axios.post(`${IP}/cardCouponCategory/selectCategory`, {});
  return resp.data;
}
// 新增一级分类
export async function addCategory(data) {
  var resp = await axios.post(`${IP}/cardCouponCategory/addCategory`, {
    ...data,
  });
  return resp.data;
}
// 修改分类
export async function updateCategory(data) {
  var resp = await axios.post(`${IP}/cardCouponCategory/updateCategory`, {
    ...data,
  });
  return resp.data;
}

// 删除分类
export async function deleteCategory(id) {
  var resp = await axios.post(`${IP}/cardCouponCategory/deleteCategory`, {
    id,
  });
  return resp.data;
}
